import React, { useEffect } from 'react'
import logo from "../assets/images/logo/logo.png"
import aos from 'aos'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Facebook, GitHub, Instagram, Linkedin, Menu, Slack, Tv, Twitter, X } from 'react-feather'
import Navbar from './Navbar'
import About from './About'
import Skills from './Skills'
import Features from './Features'
import Portfolio from './Portfolio'
import Client from './Client'
import Testimonial from './Testimonial'
import Pricing from './Pricing'
import Blog from './Blog'
import Contact from './Contact'
import Footer from './Footer'
import Work from './Work'
import data from './Data'

const Hero = () => {
    useEffect(() => {
        aos.init({ duration: 100 });
    }, [])
    return (

        <>
            <div className="template-color-1 home-classic spybody white-version" data-spy="scroll" data-target=".navbar-example2" data-offset="150">

                {/* <!-- Start Main Page Wrapper --> */}
                <main className="main-page-wrapper spybody" data-spy="scroll" data-target=".navbar-example2" data-offset="150">

                    <Navbar className="nav" />


                    {/* <!-- Start Slider Area --> */}
                    <div id="home" className="rn-slider-area">
                        {/* <!-- Start Single Slide --> */}
                        <div className="slide slider-style-4 bg_image bg_image--1">
                            <div className="container">
                                <div className="row">
                                    <div className="order-2 order-lg-1 col-lg-10 col-xl-9 mt-5">
                                        <div className="content">
                                            <div className="inner mb_sm--80">
                                                <h1 className="title">Hi, I’m<br /> <span style={{ color: "#ff014f" }}>Khuram Haseeb</span><br /> <span
                                                    className="span">Full Stack Web and Mobile Developer</span></h1>
                                                <div>
                                                    <p className="description">Well-organised person, problem solver, independent employee with high attention to detail.
                                                    <br/>
                                                        Quietly confident, naturally curious, and perpetually working on
                                                        improving my chops one design problem at a time.
                                                        <br/>
                                                        Wants to make things that make differences.
                                                        </p>
                                                        
                                                            

                                                </div>
                                            </div>
                                            <div className="row ">
                                                <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                                                    <div className="social-share-inner-left">
                                                        <span className="title">find with me</span>
                                                        <ul className="social-share d-flex liststyle">
                                                            <li className="facebook"><a href="https://app.slack.com/client/T02J391F0UE/D033DA58GP6/user_profile/U02JNJWTHC1" target="_blank"><Slack /></a>
                                                            </li>
                                                            <li className="linkedln"><a href="skype:live:khuramhaseeb1150" target="_blank"><i style={{ color: 'black', marginTop: '15px' }} className="fa-brands fa-skype fa-2x"></i></a>
                                                            </li>
                                                            <li className="instagram"><a href="https://github.com/Khuram-Haseeb1150" target="_blank"><GitHub />
                                                            </a>
                                                            </li>
                                                            <li className="instagram"><a href="https://www.linkedin.com/in/khuram-haseeb/" target="_blank"><Linkedin />
                                                            </a>
                                                            </li>
                                                            <li className="instagram"><a href="https://web.facebook.com/ranakhuram.prince.7" target="_blank"><Facebook />
                                                            </a>
                                                            </li>
                                                            <li className="instagram"><a href="https://www.behance.net/khuramhaseeb" target="_blank">                                                    
                                                                <i style={{color:"black"}} class="fa-brands fa-behance fa-1x"></i>

                                                            </a>
                                                            </li>
                                                          

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End Single Slide --> */}
                    </div>
                    {/* <!-- End Slider Area --> */}

                    <About />

                    <Skills />

                    <Features />

                    <div className="bg-image-area-fitness attachment bg_image--10 bg_image" />


                    {/* <Portfolio /> */}

                    <Work />

                    <Client />

                    <Testimonial />

                    <Pricing />

                    <Blog />

                    <Contact />

                    {/* <!-- Back to  top Start --> */}
                    {/* <div className="backto-top">
                        <div>
                            <ArrowUp />
                        </div>
                    </div> */}
                    {/* <!-- Back to top end --> */}

                </main>

                <Footer />
            </div>
        </>
    )
}

export default Hero